import React, { useRef, useState } from 'react';
import PopUp from '@/common/components/PopUp';
import Loading from '@/common/components/Loading';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { Colors } from '@/common/colors/colors';
import {
	ButtonWrapper,
	ErrorText,
	Form,
	Label,
	TextAreaField,
} from './SuspicionReportPopUp.styled';

const MIN_REASON_LENGTH = 5;

const SuspicionReportPopUp = ({ setShow, onConfirm }) => {
	const reasonRef = useRef();
	const [error, setError] = useState('');
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();

		const reportReason = reasonRef.current?.value?.trim() || '';

		if (reportReason.length < MIN_REASON_LENGTH) {
			setError(
				`Report reason must be at least ${MIN_REASON_LENGTH} characters`,
			);
			return;
		}

		setError('');
		setIsLoading(true);

		try {
			await onConfirm(reportReason);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			{isLoading && <Loading />}
			<PopUp
				padding='12px 20px'
				setShow={setShow}
				minWidth='420px'
				canOffByClickingBackground={!isLoading}
				closeIcon={!isLoading}
			>
				<Form onSubmit={handleSubmit}>
					<Label htmlFor='suspicion-report-reason'>Report reason</Label>
					<TextAreaField
						id='suspicion-report-reason'
						ref={reasonRef}
						placeholder='Enter report reason...'
						minLength={MIN_REASON_LENGTH}
						required
						disabled={isLoading}
						onChange={() => {
							if (error) {
								setError('');
							}
						}}
					/>
					{error && <ErrorText>{error}</ErrorText>}
					<ButtonWrapper>
						<SubmitButton
							text='Submit'
							color={Colors.red}
							disabled={isLoading}
						/>
					</ButtonWrapper>
				</Form>
			</PopUp>
		</>
	);
};

export default SuspicionReportPopUp;
